var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('h4',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"items"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('zg-tile',{attrs:{"href":item.href,"text":item.text,"background":_vm.background,"full-width":""}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }